
import { displayadModelinf } from './../Interfaces/displayadModelinf';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../app.constant';
import { UserdataService } from './userdata.service';


@Injectable({
  providedIn: 'root'
})
export class AdbookingService {
  private host = environment.apiHost;
  private baseUrl = `${this.host}/adbooking`;
  private baseUrl2 = `${this.host}/adPayments`;
  private baseUrl1 = `${this.host}/adDates`;
  private getFileUrl = `${this.host}/downloadFile`;
  private cancelOrderUrl =`${this.host}/orderupdate`
  // private baseUrl = "http://192.168.0.5:8081/adbooking";

  constructor(private http: HttpClient, private userdataservice: UserdataService) { }
  saveAdBookingDetails(displayadModel: any): Observable<any> {
    return this.http.post(`${this.baseUrl}`, displayadModel);
  }

  saveGuestDetails(guest: any): Observable<any> {
    const url = `${this.host}/saveguest`;
    return this.http.post(url, guest);
  }


  // private baseUrl1 = "http://192.168.0.5:8081/adDates";

  saveAdDates(displayadModel: any): Observable<any> {
    return this.http.post(`${this.baseUrl1}`, displayadModel);
  }

  // private baseUrl2 = "http://192.168.0.5:8081/adPayments";
  saveAdPayments(displayadModel: any): Observable<any> {
    return this.http.post(`${this.baseUrl2}`, displayadModel);
  }

  getorderbyid(id): Observable<any> {
    const url = `${this.host}/getorderid/` + id;
    return this.http.get(url);
  }

  savefile(file: File, orderid: string) {
    const url = `${this.host}/uploadFile`;
    const fd = new FormData();
    const email = this.userdataservice.getUserData().email;

    fd.append('file', file);
    fd.append('useremail', email);
    fd.append('orderid', orderid);
    // fd.append('image', file, file.name);
    return this.http.post(url, fd);
  }

  getFile(email: string, orderid: string, fileName: string): Observable<any> {
    return this.http.get(`${this.getFileUrl}/${email}/${orderid}/${fileName}`, { responseType: 'blob' });
  }

  getorder(email): Observable<any> {
    const url = `${this.host}/getorder/` + email;
    return this.http.get(url);
  }
 
  cancelOrder(orderid:string,status:number): Observable<any> {
    return this.http.put(`${this.cancelOrderUrl}/${orderid}`, { status });
  }

 

}
